import { offerTypeFromJsonQuery } from './offerTypeFromJsonQuery';
import { isCommercial } from '../category';
import { resetTerms } from '../helpers';
import { TJsonQuery } from '../types';

/**
 * Термы «от собственника» у вертикалей разные и ищут по разным полям: `is_by_homeowner` — жилая,
 * `is_by_commercial_owner` — коммерция. Бэк применяет оба независимо от вертикали, поэтому чужой терм
 * из URL (шаринг с мобвеба, сохранённый поиск, история) складывается по AND и опустошает выдачу.
 * Терм удаляем, а не конвертируем: множества «собственников» у вертикалей почти не пересекаются.
 */
export function removeForeignOwnerTerm(jsonQuery: TJsonQuery): TJsonQuery {
  const foreignTerm = isCommercial(offerTypeFromJsonQuery(jsonQuery)) ? 'is_by_homeowner' : 'is_by_commercial_owner';

  if (jsonQuery[foreignTerm] === undefined) {
    return jsonQuery;
  }

  return resetTerms([foreignTerm])(jsonQuery);
}
